export const isInvalidbject = (obj = {}) => {
	return typeof obj === 'object' && obj.constructor === Object && Object.keys(obj).length === 0;
};
